import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from '../shared/Typography';

import iosAppStore from '../../assets/images/ios-app-store.png';

const IOSButton = () => {
  const { t } = useTranslation('buttonIOS');
  return (
    <Text link href='https://apps.apple.com/ca/app/dot-health/id1280583948'>
      <img src={iosAppStore} alt={t('alt')} width='135' />
    </Text>
  );
};

export default IOSButton;



// WEBPACK FOOTER //
// ./src/components/shared/ButtonIOS.js